import { useEffect, useState } from "react";
import axios from "axios";
import { BellRing } from "lucide-react";
import { API } from "../../config";
import { infraT } from "./infraI18n";

export const InfraAlertHistory = ({ headers, lang = "it" }) => {
  const t = infraT(lang);
  const lg = lang === "en" ? "en" : "it";
  const [alerts, setAlerts] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/infra-resources/alerts`, { headers }).then((r) => setAlerts(r.data.alerts)).catch(() => setAlerts([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (alerts === null) return null;
  const fmt = (iso) => new Date(iso).toLocaleString(t.locale, { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  return (
    <div className="border-t border-gray-800 pt-4" data-testid="infra-alert-history">
      <p className="flex items-center gap-2 text-sm text-white font-medium mb-3"><BellRing size={15} /> {t.alerts_title}</p>
      {alerts.length === 0 ? (
        <p className="text-xs text-gray-500" data-testid="infra-alert-history-empty">{t.alerts_none}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead><tr className="text-gray-500 text-left">
              <th className="py-2 pr-4 font-normal">{t.a_date}</th><th className="py-2 pr-4 font-normal">{t.a_values}</th>
              <th className="py-2 pr-4 font-normal">{t.a_rcpt}</th><th className="py-2 font-normal">{t.a_quote}</th>
            </tr></thead>
            <tbody>
              {alerts.map((a) => (
                <tr key={a.id} className="border-t border-gray-800 text-gray-300 align-top" data-testid={`infra-alert-row-${a.id}`}>
                  <td className="py-2 pr-4 whitespace-nowrap">{fmt(a.at)}</td>
                  <td className="py-2 pr-4 whitespace-nowrap text-red-300 font-semibold">{a.values.map((v) => `${v.label[lg]} ${v.value}%`).join(" · ")}</td>
                  <td className="py-2 pr-4 text-gray-400">{a.recipients.join(", ")}</td>
                  <td className="py-2 text-gray-400">{a.quote_requests.length ? a.quote_requests.map((q) => `${q.email} (${fmt(q.at)})`).join(", ") : t.a_no}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
